import React, { ReactElement, forwardRef } from "react";
import classNames from "classnames";
import { IconProps, IconSize, IconStyle } from "./icon.types";
import { renderIconClassName } from "../utils";

export interface IconWithForwardRef
  extends React.ForwardRefExoticComponent<
    IconProps & React.RefAttributes<HTMLTableElement>
  > {
  STYLE: typeof IconStyle;
}

export const Icon = forwardRef(
  (
    {
      name,
      size = IconSize.MEDIUM,
      iconStyle,
      style,
      label,
      labelledBy,
      className,
      ...rest
    }: IconProps,
    ref
  ): ReactElement => {
    const classes = classNames(
      "spark-icon",
      renderIconClassName(name),
      { [`spark-icon--${size}`]: size && size !== IconSize.DEFAULT },
      {
        "spark-icon--fill":
          (typeof style === "string" && style === "fill") ||
          iconStyle === "fill" ||
          size === IconSize.SMALL,
      },
      className
    );

    const attr: any = {
      "aria-label": label,
      "aria-labelledby": labelledBy,
    };

    if (!label && !labelledBy) {
      attr["aria-hidden"] = true;
    }

    // Resolving deprecated style prop (describing "fill" or "line" variant) and new CSSProperties prop
    const cssStyle = typeof style === "object" ? style : {};

    return (
      <span
        ref={ref}
        className={classes}
        style={cssStyle}
        {...attr}
        {...rest}
      ></span>
    );
  }
) as IconWithForwardRef;

Icon.STYLE = IconStyle;

Icon.displayName = "Icon";
